// ======================================================================
// 📁 File: MaterialsCard.jsx
// PURPOSE:
//   Read-only Materials display for Production Planning Drawer
// ======================================================================

import React from "react";

export default function MaterialsCard({ materials = [] }) {
  return (
    <div className="card ppe-card mb-3">
      <div className="card-header">Materials</div>
      <ul className="list-group list-group-flush">
        {materials.length === 0 && (
          <li className="list-group-item text-muted">
            No materials available
          </li>
        )}

        {materials.map((m, i) => (
          <li key={i} className="list-group-item">
            {m.sku} – {m.desc}
            <span className="float-end fw-semibold">{m.qty}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
